import { HasPhysicalCardStepProps } from '@/features/onboarding/types/onboarding.types';
import { Button } from '@chikara/ui';
import styles from '../Onboarding.module.css';
import { t } from '@/i18n';

export function HasPhysicalCardStep({ onSuccess, onNoCard }: HasPhysicalCardStepProps) {
	return (
		<div className={styles.stepContainer}>
			<h2 className={styles.title}>{t('onboarding.hasPhysicalCard.title')}</h2>
			<p className={styles.subtitle} style={{ marginBottom: '32px' }}>
				{t('onboarding.hasPhysicalCard.description')}
			</p>

			<div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
				<Button onClick={onSuccess} className={styles.submitButton} style={{ width: '100%' }}>
					{t('onboarding.hasPhysicalCard.action')}
				</Button>
				<Button
					variant="secondary"
					onClick={onNoCard}
					className={styles.submitButton}
					style={{ width: '100%' }}
				>
					{t('onboarding.hasPhysicalCard.secondaryAction')}
				</Button>
			</div>
		</div>
	);
}
